// Generated by tools/stamp-version.mjs — do not edit.
export const APP_VERSION = '2026.10.08-0147';
